/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Divider, Modal, Table } from 'antd';
import moment from 'moment';

import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';

import './ModalStyle.scss';

function ConfirmationModal({ setIsVisible, onConfirm, actionType, taskList, selectedRowKeys }) {
  const [shouldDisableConfirmButton, setShouldDisableConfirmButton] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const selectedTasks = taskList.filter((task) => selectedRowKeys.includes(task.id));

  const fieldsToConfirmGeneral = [
    'startHour', // Horário de Início
    'responsiblePersonNameLogistic', // Nome Responsável
    'responsiblePersonPhoneLogistic', // Telefone Responsável
    'responsiblePersonEmailLogistic', // E-mail Responsável
    'nameResponsibleConfirmation', // Nome Responsável Confirmação
    'emailResponsibleConfirmation', // E-mail Responsável Confirmação
    'phoneResponsibleConfirmation', // Telefone Responsável Confirmação
  ];

  const fieldsToConfirmTransport = [
    'boardingHour', // Horário de Embarque
    'arrivalHour', // Previsão de Chegada
    'postalCodeLogistic', // CEP
    'streetLogistic', // Rua
    'numberLogistic', // Número
    'districtLogistic', // Bairro
    'cityLogistic', // Cidade
    'stateLogistic', // Estado
  ];

  const formatTime = (time) => (time ? moment(time).format('HH:mm') : 'Não Preenchido');
  const formatDate = (date) => (date ? moment(date).format('DD/MM/YYYY') : 'Não Preenchido');

  const getFieldList = (formData) => {
    const list = {
      comercial: [
        {
          key: 'dealClient',
          label: 'Nome do Cliente',
          value: formData.dealClient || 'Não Preenchido',
          mandatory: false,
        },
        {
          key: 'startDate',
          label: 'Data do Treinamento',
          value: formatDate(formData.startDate),
          mandatory: false,
        },
        {
          key: 'product',
          label: 'Produto + Complemento',
          value:
            formData.product && typeof formData.product === 'object'
              ? `${formData.product.name} ${formData.product.complement || ''}`.trim()
              : formData.product || 'Não Preenchido',
          mandatory: false,
        },
        {
          key: 'dealNotes',
          label: 'Observação Oficial do Negócio',
          value: formData.dealNotes || 'Não Preenchido',
          mandatory: false,
        },
        {
          key: 'commercialNotes',
          label: 'Observação Comercial',
          value: formData.commercialNotes || 'Não Preenchido',
          mandatory: false,
        },
      ],
      logistica: [
        {
          key: 'startHour',
          label: 'Horário de Início',
          value: formatTime(formData.startHour),
          mandatory: fieldsToConfirmGeneral.includes('startHour'),
        },
        {
          key: 'responsiblePersonNameLogistic',
          label: 'Nome Responsável',
          value: formData.responsiblePersonNameLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmGeneral.includes('responsiblePersonNameLogistic'),
        },
        {
          key: 'responsiblePersonPhoneLogistic',
          label: 'Telefone Responsável',
          value: formData.responsiblePersonPhoneLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmGeneral.includes('responsiblePersonPhoneLogistic'),
        },
        {
          key: 'responsiblePersonEmailLogistic',
          label: 'E-mail Responsável',
          value: formData.responsiblePersonEmailLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmGeneral.includes('responsiblePersonEmailLogistic'),
        },
        {
          key: 'nameResponsibleConfirmation',
          label: 'Nome Responsável Confirmação',
          value: formData.nameResponsibleConfirmation || 'Não Preenchido',
          mandatory: fieldsToConfirmGeneral.includes('nameResponsibleConfirmation'),
        },
        {
          key: 'emailResponsibleConfirmation',
          label: 'E-mail Responsável Confirmação',
          value: formData.emailResponsibleConfirmation || 'Não Preenchido',
          mandatory: fieldsToConfirmGeneral.includes('emailResponsibleConfirmation'),
        },
        {
          key: 'phoneResponsibleConfirmation',
          label: 'Telefone Responsável Confirmação',
          value: formData.phoneResponsibleConfirmation || 'Não Preenchido',
          mandatory: fieldsToConfirmGeneral.includes('phoneResponsibleConfirmation'),
        },
      ],
      transporte: [],
    };

    if (formData.trainingTransportation === 'Incluso') {
      list.transporte = [
        {
          key: 'boardingHour',
          label: 'Horário de Embarque',
          value: formatTime(formData.boardingHour),
          mandatory: fieldsToConfirmTransport.includes('boardingHour'),
        },
        {
          key: 'arrivalHour',
          label: 'Previsão de Chegada',
          value: formatTime(formData.arrivalHour),
          mandatory: fieldsToConfirmTransport.includes('arrivalHour'),
        },
        {
          key: 'postalCodeLogistic',
          label: 'CEP',
          value: formData.postalCodeLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmTransport.includes('postalCodeLogistic'),
        },
        {
          key: 'streetLogistic',
          label: 'Rua',
          value: formData.streetLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmTransport.includes('streetLogistic'),
        },
        {
          key: 'numberLogistic',
          label: 'Número',
          value: formData.numberLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmTransport.includes('numberLogistic'),
        },
        {
          key: 'districtLogistic',
          label: 'Bairro',
          value: formData.districtLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmTransport.includes('districtLogistic'),
        },
        {
          key: 'cityLogistic',
          label: 'Cidade',
          value: formData.cityLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmTransport.includes('cityLogistic'),
        },
        {
          key: 'stateLogistic',
          label: 'Estado',
          value: formData.stateLogistic || 'Não Preenchido',
          mandatory: fieldsToConfirmTransport.includes('stateLogistic'),
        },
      ];
    }
    return list;
  };

  const isTaskValid = (task) => {
    if (actionType !== 'confirm') {
      return true;
    }

    const generalFieldsValid = fieldsToConfirmGeneral.every((field) => {
      const value = task[field];
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== undefined && value !== null && value !== '';
    });

    if (!generalFieldsValid) {
      return false;
    }

    if (task.trainingTransportation === 'Incluso') {
      return fieldsToConfirmTransport.every((field) => {
        const value = task[field];
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        return value !== undefined && value !== null && value !== '';
      });
    }

    return true;
  };

  useEffect(() => {
    const allValid = selectedTasks.every(isTaskValid);
    setShouldDisableConfirmButton(!allValid);
  }, [selectedTasks]);

  function ExpandedRow(record) {
    const { comercial, logistica, transporte } = getFieldList(record);
    const { trainingTransportation } = record;

    return (
      <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
        <Divider orientation="left">Comercial</Divider>
        {comercial.map(({ label, value, mandatory }, index) => (
          <div key={`comercial-${index}`} style={{ marginBottom: '4px' }}>
            {mandatory ? <span style={{ color: '#d9534f' }}>* </span> : null}
            <strong>{label}:</strong>{' '}
            {value === 'Não Preenchido' ? (
              <span style={{ color: '#d9534f' }}>{value}</span>
            ) : (
              ` ${value}`
            )}
          </div>
        ))}

        <Divider orientation="left" style={{ marginTop: 40 }}>
          Logística
        </Divider>
        {logistica.map(({ label, value, mandatory }, index) => (
          <div key={`logistica-${index}`} style={{ marginBottom: '4px' }}>
            {mandatory ? <span style={{ color: '#d9534f' }}>* </span> : null}
            <strong>{label}:</strong>{' '}
            {value === 'Não Preenchido' && mandatory ? (
              <span style={{ color: '#d9534f' }}>{value}</span>
            ) : (
              ` ${value}`
            )}
          </div>
        ))}

        {trainingTransportation === 'Incluso' && transporte && transporte.length > 0 && (
          <>
            <Divider orientation="left" style={{ marginTop: 40 }}>
              Transporte
            </Divider>
            {transporte.map(({ label, value, mandatory }, index) => (
              <div key={`transporte-${index}`} style={{ marginBottom: '4px' }}>
                {/* Show asterisk if the field is mandatory for transport */}
                {mandatory ? <span style={{ color: '#d9534f' }}>* </span> : null}
                <strong>{label}:</strong>{' '}
                {value === 'Não Preenchido' && mandatory ? (
                  <span style={{ color: '#d9534f' }}>{value}</span>
                ) : (
                  ` ${value}`
                )}
              </div>
            ))}
          </>
        )}
      </div>
    );
  }

  const toggleExpandAll = () => {
    if (expandedRowKeys.length === 0) {
      setExpandedRowKeys(selectedTasks.map((task) => task.id));
    } else {
      setExpandedRowKeys([]);
    }
  };

  const columns = [
    // Só mostra a coluna de expansão quando actionType for 'confirm'
    ...(actionType === 'confirm'
      ? [
          {
            title: (
              <div style={{ textAlign: 'center' }}>
                {expandedRowKeys.length === 0 ? (
                  <PlusCircleOutlined
                    onClick={toggleExpandAll}
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                  />
                ) : (
                  <MinusCircleOutlined
                    onClick={toggleExpandAll}
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                  />
                )}
              </div>
            ),
            dataIndex: 'expand',
            key: 'expand',
            width: 50,
          },
        ]
      : []),
    {
      title: 'Id Negócio',
      dataIndex: 'dealId',
      key: 'dealId',
      width: '110px',
    },
    {
      title: 'Id Turma',
      dataIndex: 'slotClassId',
      key: 'slotClassId',
    },
    {
      title: 'Nome Cliente',
      dataIndex: 'dealClient',
      key: 'dealClient',
      width: '55%',
    },
  ];

  const buttonConfig = {
    confirm: {
      text: 'Confirmado',
      textColor: '#5cb85c',
      okButtonStyle: {
        backgroundColor: '#5cb85c',
        color: 'white',
        border: 'none',
        opacity: shouldDisableConfirmButton ? 0.3 : 1,
      },
    },
    deny: {
      text: 'Negado',
      textColor: '#d9534f',
      okButtonStyle: {
        backgroundColor: '#d9534f',
        color: 'white',
        border: 'none',
        opacity: shouldDisableConfirmButton ? 0.3 : 1,
      },
    },
    noClientContact: {
      text: 'Sem Contato com Cliente',
      textColor: '#333',
      okButtonStyle: {
        backgroundColor: '#fff',
        color: '#333',
        border: 'none',
        opacity: shouldDisableConfirmButton ? 0.3 : 1,
      },
    },
  };

  return (
    <Modal
      title="Confirmação de Ação"
      open={true}
      onOk={() => onConfirm(actionType)}
      onCancel={() => setIsVisible(false)}
      okText="Confirmar Ação"
      cancelText="Cancelar"
      width="fit-content"
      className="training-list-confirmation-modal"
      okButtonProps={{
        style: buttonConfig[actionType].okButtonStyle,
        disabled: shouldDisableConfirmButton,
      }}
    >
      <p>
        Você está prestes a alterar os registros selecionados para{' '}
        <strong style={{ color: buttonConfig[actionType].textColor }}>
          {buttonConfig[actionType].text}
        </strong>
        . Por favor, revise os detalhes abaixo e confirme se deseja prosseguir ou cancelar a
        operação.
      </p>
      {actionType === 'confirm' && (
        <p style={{ fontStyle: 'italic' }}>
          Campos com &quot;<span style={{ color: '#d9534f' }}>*</span>&quot; são obrigatórios. Caso
          algum dos registros não possua todos os campos obrigatórios preenchidos, a ação não poderá
          ser confirmada.
        </p>
      )}

      <Table
        columns={columns}
        dataSource={selectedTasks}
        pagination={false}
        rowKey="id"
        expandable={
          actionType === 'confirm'
            ? {
                expandedRowRender: (record) => ExpandedRow(record),
                rowExpandable: () => true,
                expandedRowKeys,
                onExpandedRowsChange: (expandedKeys) => setExpandedRowKeys(expandedKeys),
                expandIconColumnIndex: 0,
                expandIcon: ({ expanded, onExpand, record }) =>
                  expanded ? (
                    <MinusCircleOutlined
                      style={{ fontSize: '16px', cursor: 'pointer' }}
                      onClick={(e) => onExpand(record, e)}
                    />
                  ) : (
                    <PlusCircleOutlined
                      style={{ fontSize: '16px', cursor: 'pointer' }}
                      onClick={(e) => onExpand(record, e)}
                    />
                  ),
              }
            : {}
        }
      />
    </Modal>
  );
}

export default ConfirmationModal;
